import { render } from "./InvoiceItemsInput2.vue?vue&type=template&id=58a7795d"
import script from "./InvoiceItemsInput2.vue?vue&type=script&lang=js"
export * from "./InvoiceItemsInput2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__